<!-- Translated: skip -->
<template>
  <div :class="'unit-listing' + (grouping ? ' unit-listing--grouping' : '')">
    <transition name="animate-filter">
      <div v-if="!expanded" @click.stop="isManuallyExpanded = true" class="collapsed">
        <div class="grouping" v-if="grouping">{{grouping}}</div>
        <div class="text" v-if="!grouping">
          <button class="expanding-button" v-if="unitCount > 1">Visa alla {{ unitCount }} boendealternativ</button>
          <button class="expanding-button" v-if="unitCount === 1">Visa {{ unitCount }} boendealternativ</button>
        </div>
        <div class="text" v-if="grouping">
          <button class="button small white button-expand" v-if="unitCount > 1">Visa alla {{ unitCount }} boendealternativ <icon name="chevron-down-blue" /></button>
          <button class="button small white button-expand" v-if="unitCount === 1">Visa {{ unitCount }} boendealternativ <icon name="chevron-down-blue" /></button>
        </div>
        <div class="button-square" v-if="!grouping">
          <icon name="chevron-down-white" />
        </div>
      </div>
    </transition>
    <transition name="animate-filter">
      <div v-if="expanded" class="expanded">
        <div @click.stop="isManuallyExpanded = false" class="header" v-if="!$store.state.accomodationsFilter.freeSearch">
          <div class="grouping" v-if="grouping">{{grouping}}</div>
          <div class="text" v-if="!grouping">Stäng</div>
          <div class="text" v-if="grouping">
            <button class="button small white button-expand">Stäng <icon name="chevron-up-blue" /></button>
          </div>
          <div class="button-square" v-if="!grouping">
            <icon name="chevron-up" />
          </div>
        </div>
        <div class="body">
          <table>
            <thead>
              <tr>
                <th scope="col">
                  <span class="min-tablet">Namn</span>
                  <span class="max-mobile">Boende</span>
                </th>
                <th scope="col" class="sortable min-tablet" @click="sort('beds')">
                  Bäddar
                  <TableSortIndicator :current="isSorted('beds')" />
                </th>
                <th scope="col" class="sortable min-tablet" @click="sort('bedrooms')">
                  Sovrum
                  <TableSortIndicator :current="isSorted('bedrooms')" />
                </th>
                <th scope="col" class="sortable min-tablet" @click="sort('living_area')">
                  Boarea
                  <TableSortIndicator :current="isSorted('living_area')" />
                </th>
                <th scope="col" class="sortable min-tablet" @click="sort('distance_to_pist')">
                  Pist
                  <TableSortIndicator :current="isSorted('distance_to_pist')" />
                </th>
                <th scope="col" class="min-tablet">Typ</th>
                <th scope="col" class="no-padding min-tablet">Jämför&nbsp;boende</th>
                <th scope="col" class="min-tablet"></th>
              </tr>
            </thead>
            <transition-group name="animate-pool-list" class="animate-pool-list" tag="tbody">
              <tr v-for="(unit, index) in sortedUnits" :class="{ odd: index % 2 }" class="animate-pool-list-item" :key="unit.id" @click.stop="openInfo(unit)">
                <th scope="row" class="wrap unit-title">
                  {{ (unit.display_name || unit.description_title) }}
                  <i v-if="unit.subtitle">{{unit.subtitle}}</i>
                  <AccomodationUnitsLeft 
                    v-if="$store.state.accomodationsFilter.date.endDate"
                    :units-total="unit.unit_count"
                    :units-left="getUnitsLeft(unit.id)"
                    :unit-type="unit.accomodationtype"
                    :unit-title="(unit.display_name || unit.description_title)"
                    :unit-show="(unit.unit_lid <= 0)"
                     />

                  <b class="max-mobile" v-if="$store.state.accomodationsFilter.date.endDate">{{getPrice(unit.id) | currency}}</b>
                </th>
                <td class="facts max-mobile">
                  <div><b>Sängar: </b> {{ unit.beds }}<span v-if="unit.extra_beds">+{{ unit.extra_beds }}</span></div>
                  <div v-if="unit.living_area"><b>Boarea: </b>{{unit.living_area}}m<sup>2</sup></div>
                  <div v-if="unit.distance_to_pist"><b>Pist: </b> {{ unit.distance_to_pist }}m</div>
                  <div><b>Sovrum: </b> {{ unit.bedrooms }}</div>
                  <div v-if="unit.accomodationtype"><b>Typ: </b> {{ unit.accomodationtype.value }}</div>
                </td>
                <td class="min-tablet">{{ unit.beds }}<span v-if="unit.extra_beds">+{{ unit.extra_beds }}</span></td>
                <td class="min-tablet">{{ unit.bedrooms }}</td>
                <td class="min-tablet">{{unit.living_area}}m<sup>2</sup></td>
                <td class="min-tablet">{{ unit.distance_to_pist ? unit.distance_to_pist + 'm' : '' }}</td>
                <td class="min-tablet">{{ unit.accomodationtype ? unit.accomodationtype.value : '' }}</td>
                <td class="min-tablet">
                  <div :class="{
                    'favorite-icon-wrapper': true,
                    'active': isFavorite(unit.id)
                    }" @click.stop="toggleFavorite(unit.id)">
                  </div>
                </td>
                <td class="actions">
                  <div>
                    <button v-if="!$store.state.accomodationsFilter.date.endDate"
                      class="outline-button price-info-bt"
                      @click.stop="openPriceList(unit)"
                      >Prislista</button>
                    <b v-if="$store.state.accomodationsFilter.date.endDate"
                      @click.stop="openPriceList(unit)"
                      class="the-price"
                    >{{getPrice(unit.id) | currency}}</b>
                    <button
                      class="outline-button price-info-bt"
                      @click.stop="openInfo(unit)"
                      >{{($store.state.accomodationsFilter.date.endDate ? 'Info/boka' : 'Info')}}</button>
                    <div :class="{
                      'favorite-icon-wrapper': true,
                      'active': isFavorite(unit.id),
                      'max-mobile': true
                      }" @click.stop="toggleFavorite(unit.id)">
                    </div>
                  </div>
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import OutlineButton from '@/components/components/OutlineButton';
import TableSortIndicator from '@/components/components/TableSortIndicator';
import AccomodationUnitsLeft from '@/components/parts/Accomodation/AccomodationUnitsLeft';
import {
  flow,
  sortBy,
  reverse,
  compact,
  filter,
} from 'lodash/fp';
import {
  filterUnit,
} from '@/lib';

import moment from 'moment';

export default {
  props: ['units', 'grouping'],
  components: {
    OutlineButton,
    TableSortIndicator,
    AccomodationUnitsLeft,
  },
  data() {
    return {
      sortColumn: null,
      sortReverse: false,
      isManuallyExpanded: false,
    };
  },
  mounted() {
    if (this.$store.state.accomodationsFilter.locationId) {
      this.expanded = true;
    }
  },
  computed: {
    filteredUnits() {
      const unitFilter = filterUnit(this.$store.state.accomodationsFilter);
      return filter(unitFilter, this.units);
    },
    sortedUnits() {
      return flow(compact([
        this.sortColumn ? sortBy(this.sortColumn) : undefined,
        this.sortReverse ? reverse : undefined,
      ]))(this.filteredUnits);
    },
    unitCount() {
      return this.filteredUnits.length;
    },
    expanded() {
      if (this.$store.state.accomodationsFilter.freeSearch) {
        return true;
      }
      return this.isManuallyExpanded;
    },
    ...mapGetters([
      'favoriteAccommodations',
    ]),
  },
  methods: {
    getPrice(id) {
      if (window.prices) {
        return window.prices[id].price;
      }

      return null;
    },
    getUnitsLeft(id) {
      if (window.prices) {
        return window.prices[id] ? window.prices[id].count : null;
      }

      return null;
    },
    isFavorite(id) {
      return this.favoriteAccommodations.includes(id);
    },
    sort(column) {
      if (this.sortColumn === column) {
        this.sortReverse = !this.sortReverse;
      } else {
        this.sortColumn = column;
        this.sortReverse = false;
      }
    },
    moment(d) {
      return moment(d);
    },
    isSorted(column) {
      /* eslint-disable no-nested-ternary */
      return (
        this.sortColumn === column
        ? (
          this.sortReverse
          ? -1
          : 1
        )
        : 0
      );
    },
    openPriceList(unit) {
      this.$router.push({ path: `/boenden/pris/${unit.slug}?flow=boenden` });
    },
    openInfo(unit) {
      let image = '';
      if (this.$store.state.accomodationView && this.$store.state.accomodationView) {
        image = '/bilder';
      }

      if (this.$store.state.accomodationsFilter.date.endDate) {
        const arrival = moment(this.$store.state.accomodationsFilter.date.startDate).format('YYYY-MM-DD');
        const departure = moment(this.$store.state.accomodationsFilter.date.endDate).format('YYYY-MM-DD');
        this.$router.push({ path: `/boenden${image}/info/${unit.slug}/${arrival}/${departure}?flow=boenden` });
      } else {
        this.$router.push({ path: `/boenden${image}/info/${unit.slug}?flow=boenden` });
      }
    },
    ...mapMutations([
      'accomodationPeriodPick',
      'closeModal',
      'closeAllModals',
      'openModal',
      'pickAccomodation',
      'addFavorite',
      'removeFavorite',
    ]),
    toggleFavorite(unitId) {
      const index = this.favoriteAccommodations.indexOf(unitId);
      if (index > -1) {
        this.removeFavorite(index);
      } else {
        const $this = this;
        const favoriteCount = this.favoriteAccommodations.length;
        if (favoriteCount >= 3) {
          this.openModal(['GeneralModal', {
            title: 'Max 3 favoritboenden',
            content: '<p>Du kan endast spara 3 favoritboenden.</p>',
            buttons: [
              {
                title: 'Okej',
                class: 'small',
                click: () => {
                  $this.closeModal();
                },
              },
            ],
          }]);
        } else {
          this.addFavorite(unitId);
          if (favoriteCount === 2) {
            this.openModal(['GeneralModal', {
              title: '3 favoriter',
              content: 'Du har nu 3 favoriter tillagda för jämförelse, du kan inte lägga till fler. Vill du jämföra dem nu?',
              buttons: [{
                title: 'Ja, jämför',
                class: '',
                click: () => {
                  this.$router.push({ name: 'compare-accomodations' });
                },
              }, {
                title: 'Nej, fortsätt leta',
                class: 'white border',
                click: () => {
                  this.closeModal();
                },
              }],
            }]);
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.unit-listing
  &--grouping
    .collapsed
      background-color white
      padding: 8px
      +max-mobile()
        flex-wrap wrap
        height auto
        .text
          width 100%
          text-align left
          margin-top 4px
      .grouping
        font-weight: 600;
        font-size: 14px;
        color deep-blue
        font-family: Barlow;
  +max-mobile()
    padding-left 0px
    padding-right 0px

button.small.button-expand
  font-family: Barlow;
  font-weight: bold;
  font-size: 13px;
  padding 8px 16px
  background: #F0F7F9;
  border: 1px solid #BFD9E1;
  .icon
    margin-left 5px

.outline-button
  button-reset()
  display: inline-block
  background white
  border 1px solid light-blue
  color deep-blue
  border-radius 4px
  text-transform uppercase
  padding 0.4rem 0.4rem 0.2rem 0.4rem
  line-height 1em
  font-weight bold
  font-size 11px
  transition-ease()
  &.price-info-bt
    min-width: auto
    padding: 0.4rem 0.4rem 0.3rem 0.4rem;
    +max-mobile()
      max-width: 160px
      min-width: 40%
      float: right;

  &:hover
    border-color alpha(deep-blue, .5)
    border-bottom-width: 1px
    background-color: light-blue-grey
    color #005580
  &:focus
    outline none
    border-color deep-blue
  &.active
    background-color deep-sea-blue
    border solid 1px light-blue-grey
    color white
  &.has-text
    .icon
      position: relative;
      top: -2px
      margin-right: 5px

.component
  transition-slide('animate-filter')
  padding: 5px 6px

.collapsed
  background-color pale-sky
  border-radius 0 0 3px 3px
  height 45px
  display flex
  align-items center
  cursor pointer

  .text
    color deep-blue
    font-weight bold
    flex auto
    text-align right
    padding-right space-2
    padding-left space-2
  .button-square
    background deep-blue
    color white
    width 45px
    align-self stretch
    border-radius 0px
    position relative
    border: 0px
    .icon
      position absolute
      left -7px
      top -6px
      margin-left 50%
      margin-top 50%




.expanded
  .header
    background-color deep-blue
    color white
    height 45px
    display flex
    align-items center
    cursor pointer
    position relative
    z-index 0
  .text
    font-weight bold
    flex auto
    text-align right
    padding-right space-2
    padding-left space-2
    text-transform uppercase
    letter-spacing letter-spacing-uppercase
  .button-square
    background pale-sky
    color deep-blue
    width 45px
    align-self stretch
    border-radius 0px
    position: relative;
    border 0px
    .icon
      position absolute
      left -7px
      top -6px
      margin-left 50%
      margin-top 50%
  .grouping
    font-weight: 600;
    font-size: 14px;
    color white
    font-family: Barlow;
    padding-left 16px
  .body

    shadow()
    table
      border-collapse collapse
      width 100%
      thead
        background-color alpha(deep-blue, .85)
        color white
      tbody
        background-color white
        border-top 0
        th
          i
            font-style normal
            font-weight 300
            display block
            color greyish-brown
            margin-top 2px
            font-size 95%
        &.animate-pool-list
          transition-list('animate-pool-list')

      tbody
        tr
          cursor pointer
          &.odd
            background-color pale-sky
          &:hover
            background-color #deebf0

      th, td
        padding 10px space-2
        font-size 90%
        +max-tablet()
          padding 10px space-1
        white-space nowrap
        line-height 1.25em
        &.wrap
          white-space normal
        &.no-padding
          padding-left 0
          padding-right 0
      +max-mobile()
        th,
        td
          width 100%
          display block
          padding 5px 15px 5px
          &.min-tablet
            display none
      th.sortable
        cursor pointer
      .actions
        text-align right
        b
          font-size: 13px;
          font-weight: bold;
          letter-spacing: 0.2px;
          color: #262626;
          line-height 28px
          display inline-block
        & > div
          display flex
          margin -5px
          & > *
            margin 5px

.favorite-icon-wrapper
  background-color white
  border 1px solid #bfd9e1
  border-radius 4px
  font-size 25px
  display: inline-block
  padding 0
  background-repeat: no-repeat;
  background-position: center
  background-image url(https://static.booking.branasgruppen.se/static/svg/heart.svg)
  background-size 70%
  height 28px
  width 28px
  cursor pointer
  &:hover
    opacity 0.8
  &.active
    background-image url(https://static.booking.branasgruppen.se/static/svg/heart-red.svg)
    //background-size cover
.unit-title
  text-align left
  b
    float right

.facts
  +max-mobile()
    display flex !important
    flex-wrap wrap
    & > div
      width 50%
.the-price
  +max-mobile()
    display none !important

.expanding-button
  util-reset-button()
</style>



// WEBPACK FOOTER //
// AccomodationsListUnitsList.vue?15d35f53